import { render, staticRenderFns } from "./question-numberValue.vue?vue&type=template&id=4b490cac&scoped=true&"
import script from "./question-numberValue.vue?vue&type=script&lang=js&"
export * from "./question-numberValue.vue?vue&type=script&lang=js&"
import style0 from "./question-numberValue.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./question-numberValue.vue?vue&type=style&index=1&id=4b490cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b490cac",
  null
  
)

export default component.exports